import React, { useContext, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DropsContext } from 'contexts/DropsContext';
import { PedidosContext } from 'contexts/PedidosContext';
import { GridContext } from 'contexts/GridContext';
import { useModal } from 'components/Modals';
import ResumoModal from 'components/Modals/ResumoModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import DataView, { useDataViewFilters } from 'components/DataView';
import getPedidosFilterFields from './filterFields';
import columnOverrides from './columnOverrides';

const Pedidos = () => {
  const rotina = 'PedidosCompra';
  const titulo = 'Pedidos de Compra';
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { openModal, closeModal } = useModal();
  const { drops } = useContext(DropsContext);
  const { exportPdf, exportXls } = useContext(GridContext);
  const { pedidos, getPedidos, getLoading } = useContext(PedidosContext);
  const filterFields = useMemo(() => getPedidosFilterFields(drops), [drops]);

  const { applyFilter, filterForm } = useDataViewFilters({
    fields: filterFields,
    searchParams,
    setSearchParams,
    onApply: (props) => loadGrid(props),
  });
  const { getValues } = filterForm;

  const loadGrid = (props = {}) => {
    const filter = props?.filter || getValues();
    closeModal();
    getPedidos({ ...props, rotina, filter });
  };

  const toolbarActions = [
    { name: 'Adicionar Pedido', icon: 'add', placement: 'primary', action: () => navigate('/app/Pedidos/Gerar') },
    { name: 'Exportar PDF', icon: 'file_download', action: () => exportPdf({ rotina, filter: getValues(), order: pedidos?.order }) },
    { name: 'Exportar XLS', icon: 'file_download', action: () => exportXls({ rotina, filter: getValues(), order: pedidos?.order }) },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={pedidos?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', { state: { rotina, group, filter: getValues() } })
            }
          />
        ),
    },
  ];

  const rowActions = [
    { name: 'Aprovação necessária', icon: 'priority_high', color: 'secondary.main', show: ({ row }) => row?.aprovacao === 'PENDENTE' },
    { name: 'Aprovado', icon: 'check', color: 'primary.main', show: ({ row }) => row?.aprovacao === 'SIM' },
    { name: ' Reprovado', icon: 'close', color: 'secondary.main', show: ({ row }) => row?.aprovacao === 'NAO' },
    { name: 'Detalhes', icon: 'visibility', action: ({ row }) => navigate(`/app/Documento/${row?.id}`) },
  ];

  return (
    <Container fillHeight>
      <Header rotina={rotina} titulo={titulo} colunas={pedidos?.colunas} />
      <Card fillHeight>
        <DataView
          fillHeight
          grid={pedidos}
          filterFields={filterFields}
          filterForm={filterForm}
          onFilter={applyFilter}
          columnOverrides={columnOverrides}
          toolbarActions={toolbarActions}
          rowActions={rowActions}
          checkboxSelection
          loading={getLoading}
          loadGrid={loadGrid}
        />
      </Card>
    </Container>
  );
};

export default Pedidos;
